import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "rax_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch {
            return [];
        }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        } catch {
            /* noop */
        }
    }, [items]);

    const add = useCallback((product) => {
        setItems((prev) => {
            if (prev.find((p) => p.id === product.id)) return prev;
            return [
                ...prev,
                {
                    id: product.id,
                    title: product.title,
                    designer: product.designer,
                    price: product.price,
                    size: product.size,
                    image: (product.images || [])[0],
                },
            ];
        });
        setOpen(true);
    }, []);

    const remove = useCallback((id) => {
        setItems((prev) => prev.filter((p) => p.id !== id));
    }, []);

    const clear = useCallback(() => setItems([]), []);

    const count = items.length;
    const subtotal = items.reduce((s, i) => s + Number(i.price || 0), 0);

    return (
        <CartContext.Provider
            value={{ items, add, remove, clear, count, subtotal, open, setOpen }}
        >
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    return useContext(CartContext);
}
